import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://api.helm.thehybridconsultant.net';

const styles = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', background: 'var(--bg)' },
  card: { width: '100%', maxWidth: '400px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '40px' },
  logo: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '32px' },
  logoIcon: { width: '32px', height: '32px', background: 'var(--accent)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' },
  logoText: { fontSize: '18px', fontWeight: '600', letterSpacing: '-0.3px' },
  title: { fontSize: '22px', fontWeight: '600', marginBottom: '6px', letterSpacing: '-0.3px' },
  sub: { color: 'var(--text-muted)', fontSize: '13px', marginBottom: '28px' },
  field: { marginBottom: '16px' },
  label: { display: 'block', fontSize: '12px', color: 'var(--text-dim)', marginBottom: '6px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: { width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '10px 14px', color: 'var(--text)', fontSize: '14px', outline: 'none', transition: 'border-color 0.15s' },
  btn: { width: '100%', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 'var(--radius)', padding: '11px', fontSize: '14px', fontWeight: '500', marginTop: '8px', transition: 'background 0.15s' },
  toggle: { textAlign: 'center', marginTop: '20px', fontSize: '13px', color: 'var(--text-muted)' },
  toggleLink: { color: 'var(--accent)', cursor: 'pointer', marginLeft: '4px' },
  error: { background: 'rgba(248,113,113,0.1)', border: '1px solid rgba(248,113,113,0.3)', borderRadius: 'var(--radius)', padding: '10px 14px', color: 'var(--danger)', fontSize: '13px', marginBottom: '16px' },
};

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const endpoint = mode === 'login' ? '/auth/login' : '/auth/register';
      const { data } = await axios.post(`${API}${endpoint}`, form);
      login(data.token, data.user);
      navigate('/orgs');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <div style={styles.logoIcon}>⛵</div>
          <span style={styles.logoText}>Salesforce Helm</span>
        </div>
        <div style={styles.title}>{mode === 'login' ? 'Welcome back' : 'Create account'}</div>
        <div style={styles.sub}>{mode === 'login' ? 'Sign in to your workspace' : 'Set up your Helm workspace'}</div>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handle}>
          {mode === 'register' && (
            <div style={styles.field}>
              <label style={styles.label}>Name</label>
              <input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" />
            </div>
          )}
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input style={styles.input} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input style={styles.input} type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="••••••••" required />
          </div>
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Please wait...' : mode === 'login' ? 'Sign in' : 'Create account'}
          </button>
        </form>
        <div style={styles.toggle}>
          {mode === 'login' ? "Don't have an account?" : 'Already have an account?'}
          <span style={styles.toggleLink} onClick={() => setMode(mode === 'login' ? 'register' : 'login')}>
            {mode === 'login' ? 'Register' : 'Sign in'}
          </span>
        </div>
      </div>
    </div>
  );
}
